import React, { ReactNode, isValidElement, cloneElement, Children } from 'react';
import device from 'common/support/device';

interface AriaHiddenOnVegaProps {
  children: ReactNode;
  ttsText?: string;
}

const hideDescendants = (node: ReactNode): ReactNode =>
  Children.map(node, child =>
    isValidElement(child) ? (
      cloneElement(child, { 'aria-hidden': 'true' } as Record<string, unknown>)
    ) : (
      <span aria-hidden="true">{child}</span>
    ),
  );

const AriaHiddenOnVega = ({ children, ttsText }: AriaHiddenOnVegaProps) => {
  let isTtsApplied = false;

  if (!device.isVega) {
    return <>{children}</>;
  }

  return (
    <>
      {Children.map(children, child => {
        if (!isValidElement(child)) {
          return <span aria-hidden="true">{child}</span>;
        }

        const { children: childChildren } = child.props as {
          children?: ReactNode;
        };
        const clonedItem = cloneElement(child, {
          ...(!isTtsApplied ? { 'aria-label': ttsText }  : {}),
          children: hideDescendants(childChildren),
        } as Record<string, unknown>);

        isTtsApplied = true;

        return clonedItem;
      })}
    </>
  );
};

export default AriaHiddenOnVega;
